import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useCurrentClinicId } from "@/hooks/useAppointments";
import { buildReportRpcParams } from "@/pages/reports/prescriptions/rpc-params";
import { mapReportRows, type RawPrescriptionReportRow } from "@/pages/reports/prescriptions/map-rows";
import type { PrescriptionsReportFilters, PrescriptionsReportResult } from "@/pages/reports/prescriptions/types";

export function useMapaPrescriptionsReport(filters: PrescriptionsReportFilters) {
  const { data: clinicId } = useCurrentClinicId();
  const params = buildReportRpcParams(filters);

  return useQuery<PrescriptionsReportResult>({
    enabled: Boolean(clinicId) && Boolean(filters.from) && Boolean(filters.to),
    queryKey: ["mapa-prescriptions-report", clinicId, params],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const { data, error } = await supabase.rpc(
        "get_mapa_prescriptions_report" as never,
        params as never,
      );
      if (error) throw error;
      return mapReportRows(data as unknown as RawPrescriptionReportRow[] | null);
    },
  });
}

export interface MapaReportVeterinarian {
  id: string;
  full_name: string;
}

export function useMapaReportVeterinarians() {
  const { data: clinicId } = useCurrentClinicId();

  return useQuery<MapaReportVeterinarian[]>({
    enabled: Boolean(clinicId),
    queryKey: ["mapa-report-veterinarians", clinicId],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_mapa_report_veterinarians" as never);
      if (error) throw error;
      return (data ?? []) as unknown as MapaReportVeterinarian[];
    },
  });
}
